{
  "open": "Удалённый рабочий стол",
  "unavailable": "Удалённый рабочий стол в этой установке панели не настроен: нет шлюза RDP. Обратитесь к администратору.",
  "picker": {
    "kind": "Как подключиться",
    "ssh": "Терминал (SSH)",
    "sshHint": "Командная строка Linux и других Unix-систем.",
    "rdp": "Удалённый рабочий стол (RDP)",
    "rdpHint": "Рабочий стол Windows в окне браузера: мышь, клавиатура, буфер обмена.",
    "vnc": "Консоль (VNC)",
    "vncHint": "Экран сервера, как монитор: работает без сети и SSH, видно загрузку и ошибки ядра.",
    "vncNote": "Консоль откроется вкладкой. Войдите на экране сервера, как за его монитором: пароль спросит сама система."
  },
  "signIn": {
    "user": "Пользователь Windows",
    "userHint": "По умолчанию Administrator. Панель запомнит имя для этого сервера.",
    "password": "Пароль",
    "passwordHint": "Нужен для одного входа: панель его не хранит и не записывает. При переподключении введите его снова.",
    "domain": "Домен (необязательно)",
    "domainHint": "Только для учётных записей домена Active Directory."
  },
  "reach": {
    "title": "Доступ к порту 3389",
    "open": "Открыт для панели.",
    "blocked": "Закрыт файрволом: {{names}}. Панель не сможет подключиться.",
    "unknown": "Адрес панели не задан, поэтому проверить правила нельзя: порт 3389 открыт не для всех.",
    "noAddress": "У сервера нет публичного адреса: рабочему столу не к чему подключиться.",
    "allowHint": "Добавит в файрвол «{{name}}» правило: входящий TCP 3389 с {{ips}}.",
    "exposed": "Порт 3389 открыт для всего интернета: к серверу будут подбирать пароли. Закройте его файрволом и разрешите только адрес панели."
  },
  "status": {
    "signingIn": "Входим в Windows…"
  },
  "failure": {
    "unreachable": {
      "title": "Сервер не отвечает на RDP",
      "text": "Шлюз не смог подключиться к порту 3389. Возможно, его закрывает файрвол, удалённый рабочий стол в Windows выключен или сервер ещё загружается."
    },
    "timeout": {
      "title": "Сервер не ответил вовремя",
      "text": "Соединение не установилось вовремя. Проверьте файрвол и что Windows загрузилась."
    },
    "auth_failed": {
      "title": "Windows не приняла вход",
      "text": "Неверное имя пользователя или пароль — или на сервере выключена проверка подлинности на уровне сети (NLA), без которой панель не подключается."
    },
    "forbidden": {
      "title": "Этой учётной записи вход запрещён",
      "text": "Пароль верный, но Windows не пускает: учётная запись заблокирована или отключена, пароль истёк или у неё нет права входить через удалённый рабочий стол."
    },
    "session_conflict": {
      "title": "Сеанс занят другим подключением",
      "text": "К этому рабочему столу подключился кто-то ещё (или вы с другого устройства). Войдите снова, чтобы забрать сеанс."
    },
    "gateway_unavailable": {
      "title": "Шлюз RDP недоступен",
      "text": "Служба, через которую панель подключается к рабочему столу, не отвечает. Попробуйте позже или обратитесь к администратору."
    },
    "gateway_error": {
      "title": "Ошибка шлюза RDP",
      "text": "Шлюз не смог открыть рабочий стол. Попробуйте ещё раз; если повторится — обратитесь к администратору."
    },
    "idle": {
      "title": "Сеанс закрыт из-за бездействия",
      "text": "30 минут не было ни клавиш, ни мыши. Войдите снова — программы в Windows продолжают работать."
    },
    "lifetime": {
      "title": "Сеанс закончился",
      "text": "Сеанс может длиться до 8 часов. Войдите снова, чтобы продолжить."
    },
    "closed": {
      "title": "Сеанс закрыт",
      "text": "Соединение с рабочим столом завершилось. Войдите снова, чтобы продолжить."
    },
    "expired": {
      "title": "Сеанс устарел",
      "text": "Ссылка на подключение уже использована или истекла. Войдите снова."
    }
  },
  "workspace": {
    "title": "Удалённый рабочий стол {{name}}",
    "signIn": "Войти"
  },
  "clipboard": {
    "remoteEmpty": "Буфер рабочего стола пуст: сначала скопируйте текст в Windows.",
    "copy": "Копировать из буфера рабочего стола",
    "copied": "Буфер рабочего стола скопирован к вам",
    "sent": "Текст в буфере рабочего стола: вставьте его там сочетанием Ctrl+V",
    "readFailed": "Браузер не дал прочитать буфер обмена. Наберите текст в окне — он будет набран на рабочем столе клавишами."
  },
  "setup": {
    "title": "Удалённый рабочий стол",
    "intro": "Панель открывает рабочий стол Windows прямо в браузере, во вкладке верхней панели. Имя и пароль Windows вводятся для каждого сеанса и нигде не хранятся. На сервере должен быть включён удалённый рабочий стол с проверкой подлинности на уровне сети (NLA)."
  }
}
